import './Index.scss';
import { coreActions } from '@sonar-software/sonar-core';
import { InitiativeCard } from './InitiativeCard';
import { PatchInitiativeNotifications } from '../notifications';
import React from 'react';
import { useParams } from 'react-router-dom';
import { ViewArea } from '@ui/general';
import { useAction, useOnMount, useOnUnmount } from '@hooks';
export const InitiativeDetailIndex = () => {
    const { id } = useParams();
    const getInitiative = useAction(coreActions.requestGetCoreInitiativesById);
    const getUsers = useAction(coreActions.requestGetCoreUsersAll);
    const resetInitiative = useAction(coreActions.resetGetCoreInitiativesById);
    const resetInitiativeScopes = useAction(coreActions.resetGetCoreInitiativesSonarObjects);
    const initiativeId = Number(id);
    useOnMount(() => {
        getInitiative({
            id: initiativeId
        });
        getUsers();
    });
    useOnUnmount(() => {
        resetInitiative();
        resetInitiativeScopes();
    });
    return (React.createElement(ViewArea, { collapseSidebar: true, fullWidth: true, id: 'initiative-view', showPeriscopes: true },
        React.createElement(InitiativeCard, { initiativeId: initiativeId }),
        React.createElement(PatchInitiativeNotifications, null)));
};
